import React, { Component } from 'react'
import {Outlet } from 'react-router-dom';
import Footer from './Footer'
import Header from './Header'
export default class Layout extends Component {
  render() {
    return (
      <div>
        <Header/>
        <div className='container p-0'>
         <Outlet />
        </div>
        <Footer/>
      </div>
    )
  }
}
